import React, { useState, useEffect } from "react";
import FormikControl from '../../../hoc/formikComponents/FormikControl.js'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import moment from 'moment'

export default function ContractReview() {
    const { orgcode } = useParams()
    const history = useHistory();
    const [data, setData] = useState({
        orgCode: 0,
        reqDate: new Date(),
        contractDate: new Date(),
        address: "",
        scope: "",
        riskLevel: "",
        nabcbSicCode: "",
        permanentEmp: "",
        partTimeEmp: "",
        temporaryEmp: "",
        totalEmp: "",
        effectiveNoEmpToBeAudited: "",
        noOfShifts: "",
        justificationEffNoEmpConsideration: "",
        sitesTobeCoveredInAudit: "",
        nameOfConsultantOrBussinessAsso: "",
        mandays: "",
        mandaysPlanned: "",
        stageOneAudit: "",
        stageTwoAudit: "",
        remarkforInsDecMandyas: "",
        resonOfTransfer: "",
        threatOne: "",
        threatOneremark: "",
        threatTwo: "",
        threatTworemark: "",
        threatThree: "",
        threatThreeremark: "",
        threatFour: "",
        threatFourremark: "",
        threatFive: "",
        threatFiveremark: "",
        threatSix: "",
        threatSixremark: "",
        threatSeven: "",
        threatSevenremark: "",
        threatEight: "",
        threatEightremark: "",
        threatNine: "",
        threatNineremark: "",
        threatTen: "",
        threatTenremark: "",
        auditTrainVerification: "",
        scopeCoveredByaccreditation: "",
        outSourceActivity: "",
        notApplicableRequirement: "",


        qualifiedAuditorAppoint: "",
        technicalExpert: "",
        coAuditor: "",
        applicationAcceptedRejected: "",
        reviewConductedBy: "",
        externalReviewConductedBy: "",
        approvedBy: "",
        appvDate: new Date(),



    });
    const { data: Rfqdata, isLoading } = useQuery(
        'listrfq',
        () => {
            if (orgcode) {
                Fetcher('get', '/api/rfq/get/orgdetails/' + orgcode, {})
            }
        }
    )
    useEffect(() => {
        if (Rfqdata && data.orgCode === 0) {
            var tempData = Rfqdata.data.response
            tempData.reqDate = Date.parse(tempData.reqDate);
            tempData.contractDate = Date.parse(tempData.contractDate);
            tempData.appvDate = Date.parse(tempData.appvDate);
                  setData(tempData)

        }
    }, [orgcode && !isLoading && data.orgCode === 0])
    const [currentStep, setCurrentStep] = useState(0);
    const makeRequest = (formData) => {
        mutation.mutate(formData)
    };
    const mutation = useMutation((params) => Fetcher('patch', '/api/rfq/patch/contractreview', params), {
        onSuccess(data) {
          
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Contract Review and Audit Team Info Filled')
                history.push('/admin/view/contractreview/' + data.data.response.orgCode);
            } else {
                var msg = 'Contract Review - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Contract Review' + error)
        }
    })
    const handleNextStep = (newData, final = false) => {
        setData((prev) => ({ ...prev, ...newData }));
        alert("data")
        if (final) {
            makeRequest(newData);
            return;
        }
        setCurrentStep((prev) => prev + 1);
    };
    const handlePrevStep = (newData) => {
        setData((prev) => ({ ...prev, ...newData }));
        setCurrentStep((prev) => prev - 1);
    };

    const steps = [
        <StepOne next={handleNextStep} data={data} updateData={setData} />,
        <StepTwo next={handleNextStep} prev={handlePrevStep} data={data} />
    ];
   
    if(orgcode && isLoading && data.orgCode === 0 ) return <h1>Loading</h1>
    return <div className="ContractreView">{steps[currentStep]}</div>;
}

const rsklevel = [

    { key: 'Select', value: '-' },
    { key: 'High', value: 'High' },
    { key: 'Medium', value: 'Medium' },
    { key: 'Low', value: 'Low' }
]
const yesNo = [

    { key: 'Select', value: '-' },
    { key: 'Yes', value: 'Yes' },
    { key: 'No', value: 'No' },

]
const increase = [
    { key: 'Complicated logistics ', value: 'Complicated logistics ' },
    { key: 'Interpreter needed', value: 'Interpreter needed' },
    { key: 'Very large site/number of employees ', value: 'Very large site/number of employees ' },
    { key: 'High degree of regulation', value: 'High degree of regulation ' }
]
// const stepOneValidationSchema = Yup.object({
//         // reqDate                         :  Yup.string().required().label("Request Date"),
//         // contractDate                    :  Yup.string().required().label("Contract Date"),
//         orgCode                     :  Yup.string().required().label("Company Name"),
//         // scope                           :  Yup.string().required().label("scope"),
//         // riskLevel                       :  Yup.string().required('Required!!'),
//         // nabcbSicCode                    :  Yup.string().required('Required!!'),
//         // permtEmployees                  :  Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
//         // empPerShift                     :  Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
//         // temporaryEmps                   :  Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
//         // totalNoEmployees                :  Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
//         // effectiveNoEmpToAudit           :  Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
//         // noOfShifts                      :  Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
//         // justificationForEffectiveNoEmp  :  Yup.string().required('Required!!'),
//         // sitesTobeCoveredInAudit         :  Yup.string().required('Required!!'),
//         // nameOfConsultantOrBussinessAsso :  Yup.string().required('Required!!'),
//         // mandays                         :  Yup.string().required('Required!!'),
//         // mandaysPlanned                  :  Yup.string().required('Required!!'),
//         // stageOneAudit                   :  Yup.string().required('Required!!'),
//         // stageTwoAudit                   :  Yup.string().required('Required!!'),
//         // remarkforInsDecMandyas          :  Yup.string().required('Required!!'),
//         // resonOfTransfer                 :  Yup.string().required('Required!!'),
//         // threatOne                       :  Yup.string().required('Required!!'),
//         // threatOneremark                 :  Yup.string().required('Required!!'),
//         // threatTwo                       :  Yup.string().required('Required!!'),
//         // threatTworemark                 :  Yup.string().required('Required!!'),
//         // threatThree                     :  Yup.string().required('Required!!'),
//         // threatThreeremark               :  Yup.string().required('Required!!'),
//         // threatFour                      :  Yup.string().required('Required!!'),
//         // threatFourremark                :  Yup.string().required('Required!!'),
//         // threatFive                      :  Yup.string().required('Required!!'),
//         // threatFiveremark                :  Yup.string().required('Required!!'),
//         // threatSix                       :  Yup.string().required('Required!!'),
//         // threatSixremark                 :  Yup.string().required('Required!!'),
//         // threatSeven                     :  Yup.string().required('Required!!'),
//         // threatSevenremark               :  Yup.string().required('Required!!'),
//         // threatEight                     :  Yup.string().required('Required!!'),
//         // threatEightremark               :  Yup.string().required('Required!!'),
//         // threatNine                      :  Yup.string().required('Required!!'),
//         // threatNineremark                :  Yup.string().required('Required!!'),
//         // threatTen                       :  Yup.string().required('Required!!'),
//         // auditTrainVerification          :  Yup.string().required('Required!!'),
//         // scopeCoveredByaccreditation     :  Yup.string().required('Required!!'),
//         // outSourceActivity               :  Yup.string().required('Required!!'),
//         // notApplicableRequirement        :  Yup.string().required('Required!!'),

// });
const StepOne = (props) => {
    const [initialValues, setInitialValues] = useState(props.data);
  
    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        props.next(values);
    };

    const { data: OrgList, isLoading: orgLoading } = useQuery(
        'listorg',
        () => Fetcher('get', '/api/rfq/get/listofcompanies', {}))

    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/rfq/get/orgdetails/' + params, {}), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                tempInitialValues.nacecode = data.data.response.nacecode || "";
                tempInitialValues.effectivenumber = data.data.response.effectiveNoEmpToBeAudited || "";
                tempInitialValues.noofshifts = data.data.response.noOfShifts || "";
               // tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null;
                tempInitialValues.auditteam = data.data.response.auditteam || "";
                tempInitialValues.teamleader = data.data.response.teamleader || "";
                tempInitialValues.permanentEmp = data.data.response.permanentEmp || "";

                setInitialValues(tempInitialValues)
            } else {
                var msg = 'Company - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            // ToastInstance('Error', 'Get Company Details' + error)
        }
    })
    if (orgLoading) return <h1>Loading</h1>
 
    return (
        <Formik
            enableReinitialize={true}
            //validationSchema={stepOneValidationSchema}
            initialValues={initialValues}
            onSubmit={handleSubmit}
        >
            {
                () => (
                    <Form>
                        <div className="content-wrapper">
                            <section className="content">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card-body" style={{ paddingLeft: "4rem", paddingTop: "1rem", paddingRight: "6rem" }}>
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <form>
                                                            <div className="row ">
                                                                <div className="col-sm-6 text-dark ">
                                                                    <h5>General Information</h5>
                                                                </div>
                                                            </div>
                                                            <hr />
                                                            <div className="row">
                                                                <label htmlFor="staticEmail" className="col-sm-2">Company Name</label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='select' options={OrgList.data.response} name='orgCode' onClick={e => { mutationgetCompanyDetails.mutate(e.currentTarget.value); }} />
                                                                </div>
                                                                <label htmlFor="staticEmail" className="col-sm-2">Address</label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='textarea' type="text" name='address' disabled={true} />
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-2">Request Date</label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='date' dateFormat="dd-MM-yyyy" name='reqDate' />
                                                                </div>
                                                                <label htmlFor="staticEmail" className="col-sm-2">Contract Date</label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='date' dateFormat="dd-MM-yyyy" name='contractDate' />
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-2">Scope</label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='input' type="text" name='scope' />
                                                                </div>
                                                                <label htmlFor="staticEmail" className="col-sm-2">Risk Level</label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='select' options={rsklevel} name='riskLevel' />
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-2">NABCB-SIC Code</label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='input' type="text" name='nabcbSicCode' />
                                                                </div>
                                                                <label htmlFor="staticEmail" className="col-sm-2">No Of Shifts</label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='input' type="text" name='noOfShifts' />
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-2">Permenant Employees</label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='input' type="text" name='permanentEmp' disabled={true} />
                                                                </div>
                                                                <label htmlFor="staticEmail" className="col-sm-2">Employees Per Shift / Part Time Employees</label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='input' type="text" name='partTimeEmp' disabled={true} />
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-2">Temporary Employees</label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='input' type="text" name='temporaryEmp' disabled={true} />
                                                                </div>
                                                                <label htmlFor="staticEmail" className="col-sm-2">Total No of Employees</label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='input' type="text" name='totalEmp' disabled={true} />
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-4">Effective Number of Employees to be Audited</label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='input' type="text" name='effectiveNoEmpToBeAudited' disabled={true} />
                                                                </div>
                                                                <h6 className="mt-5">( Note:- For repetitive processes and for shifts the effective numbers may be reduced*)
                                                                    Justification for Effective Number of Employees Consideration:-
                                                                    ( Ex- Shift/ Repetitive Work/ unskilled Employees).</h6>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-4">Justification for Effective Number of Employees Consideration </label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='input' type="text" name='justificationEffNoEmpConsideration' disabled={true} />
                                                                </div>
                                                                <h6 className="mt-5">( Note:- For repetitive processes and for shifts the effective numbers may be reduced*)
                                                                    ( Ex- Shift/ Repetitive Work/ unskilled Employees).</h6>
                                                            </div>

                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-4">Sites to be covered in Audit </label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='input' type="text" name='sitesTobeCoveredInAudit' />
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-4">Name of the Consultant / Business associates (if any)  </label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='input' type="text" name='nameOfConsultantOrBussinessAsso' />
                                                                </div>
                                                                <div className="row mt-4">
                                                                    <label htmlFor="staticEmail" className="col-sm-4">Mandays required (Stage1 & Stage 2/Recertification)</label>
                                                                    <div className="col-sm-4">
                                                                        <FormikControl control='input' type="text" name='mandays' />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-1">Mandays Planned </label>
                                                                <div className="col-sm-3">
                                                                    <FormikControl control='input' type="text" name='mandaysPlanned' />
                                                                </div>
                                                                <label htmlFor="staticEmail" className="col-sm-1">Stage 1 Audit</label>
                                                                <div className="col-sm-3">
                                                                    <FormikControl control='input' type="text" name='stageOneAudit' />
                                                                </div>
                                                                <label htmlFor="staticEmail" className="col-sm-1">Stage 2 Audit</label>
                                                                <div className="col-sm-3">
                                                                    <FormikControl control='input' type="text" name='stageTwoAudit' />
                                                                </div>
                                                                <h6>Note: - For each justification of decrease 10% reduction will be given, in any case not exceeding 30%.
                                                                    MT in consultation with DT ensure that the auditor allocation & audit planning/s scheduling is done in such a way that spending of 80% time onsite is conveyed/ confirmed with auditors.
                                                                </h6>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-4">Remarks for Reducing/ Increasing the Mandays with respect to effective number of employees/ scope and Risk Level  </label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='input' type="text" name='remarkforInsDecMandyas' />
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-4">Reason of the transfer to IQCPL from another Certification Body </label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='input' type="text" name='resonOfTransfer' />
                                                                </div>
                                                            </div>
                                                            <hr/>
                                                            <div className="row">
                                                            <div className="col-sm-6 text-dark">
                                                                <h5 className="mb-3">Any threat to impartiality</h5>
                                                            </div>
                                                            <hr/>
                                                            <div className="row ">
                                                                <table className="table table-bordered">
                                                                    <thead className="table-primary">
                                                                        <tr>
                                                                            <th>#</th>
                                                                            <th scope="col" className="text-center" width="50%">Type of Threat</th>
                                                                            <th scope="col" className="text-center">Yes/No</th>
                                                                            <th scope="col" className="text-center">Comments/Remarks</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody >
                                                                        <tr >
                                                                            <td className="text-center" >1.</td>
                                                                            <td>Ownership, Governance and Management Current boards of directors are responsible for this area.
                                                                            </td>
                                                                            <td> <FormikControl control='select' options={yesNo} name='threatOne' style={{textAlign:"center"}}/></td>
                                                                            <td ><FormikControl control='input' type="text" name='threatOneremark' /> </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="text-center">2.</td>
                                                                            <td>Personnel (on Roll) at auditing/Review-Relatives working in top level.
                                                                            </td>
                                                                            <td> <FormikControl control='select' options={yesNo} name='threatTwo' /></td>
                                                                            <td><FormikControl control='input' type="text" name='threatTworemark' /> </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="text-center">3.</td>
                                                                            <td>-Previous Employment
                                                                                -Holding Shares with the organization to be Certified.
                                                                            </td>
                                                                            <td> <FormikControl control='select' options={yesNo} name='threatThree' /></td>
                                                                            <td><FormikControl control='input' type="text" name='threatThreeremark' /> </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="text-center">4.</td>
                                                                            <td>Impartiality in Handling Application from own group of companies
                                                                            </td>
                                                                            <td> <FormikControl control='select' options={yesNo} name='threatFour' /></td>
                                                                            <td><FormikControl control='input' type="text" name='threatFourremark' /> </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="text-center">5.</td>
                                                                            <td>The possibility of Impartial Committee member influencing the auditing process
                                                                                If the Impartial committee member has any link with Client organization.
                                                                            </td>
                                                                            <td> <FormikControl control='select' options={yesNo} name='threatFive' /></td>
                                                                            <td><FormikControl control='input' type="text" name='threatFiveremark' /> </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="text-center">6.</td>
                                                                            <td>May be the clients representative is having the financial interest in IQCPL
                                                                            </td>
                                                                            <td> <FormikControl control='select' options={yesNo} name='threatSix' /></td>
                                                                            <td><FormikControl control='input' type="text" name='threatSixremark' /> </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="text-center">7.</td>
                                                                            <td>May be the impartiality committee members have association with the clients.
                                                                            </td>
                                                                            <td> <FormikControl control='select' options={yesNo} name='threatSeven' /></td>
                                                                            <td><FormikControl control='input' type="text" name='threatSevenremark' /> </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="text-center">8.</td>
                                                                            <td>Marketing Team may offer quick/Easy certification and may propose to do the consultancy and audits.
                                                                                Employees of the clients may offer the above situation
                                                                            </td>
                                                                            <td> <FormikControl control='select' options={yesNo} name='threatEight' /></td>
                                                                            <td><FormikControl control='input' type="text" name='threatEightremark' /> </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="text-center">9.</td>
                                                                            <td>Repeatedly sending the same auditor to the clients place may have an impact by development of the relationship
                                                                            </td>
                                                                            <td> <FormikControl control='select' options={yesNo} name='threatNine' /></td>
                                                                            <td><FormikControl control='input' type="text" name='threatNineremark' /> </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="text-center">10.</td>
                                                                            <td>Family Members are directly involved in operating the management system consultancy business
                                                                            </td>
                                                                            <td> <FormikControl control='select' options={yesNo} name='threatTen' /></td>
                                                                            <td><FormikControl control='input' type="text" name='threatTenremark' /> </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                                </div>
                                                            </div>
                                                                <div className="row mt-4">
                                                                    <label htmlFor="staticEmail" className="col-sm-4">Auditor training verification </label>
                                                                    <div className="col-sm-4">
                                                                        <FormikControl control='select' options={yesNo} name='auditTrainVerification' />
                                                                    </div>
                                                                </div>
                                                                
                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-4">Is the scope covered by accreditation? </label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='select' options={yesNo} name='scopeCoveredByaccreditation' />
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-4">Outsource activities performed </label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='input' type='text' name='outSourceActivity' />
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-4"> Does your company have any Not Applicable requirements identified,
                                                                    if yes please list them out and provide the reasons
                                                                    justification for non-applicability </label>
                                                                <div className="col-sm-4">
                                                                    <FormikControl control='input' type='text' name='notApplicableRequirement' />
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                        {/* <div className="row">
                            <div className="col-lg-11"></div>
                            <div className="col-lg-1" >
                                <button type="submit" className="btn btn-primary mt-5">Next</button>                            </div>
                        </div> */}
                         <div className="card-footer">
                                <div className="row">
                                <div className="col-sm-10"></div>
                                <div className="col-sm-2">
                                    <button type="submit" className="btn btn-primary float-right">Next</button>
                                </div>
                                
                            </div>
                            </div>
                    </Form>
                )}
        </Formik>
    );
};

// const stepTwoValidationSchema = Yup.object({
//     qualifiedAuditorAppoint: Yup.string().required().label("Qualification Auditor Appointment!!"),
//     technicalExpert: Yup.string().required().label("Technical Expert"),
//     coAuditor: Yup.string().required().label("Co Auditor")
// });

const StepTwo = (props) => {
    const handleSubmit = (values) => {
        props.next(values, true);
    };
    return (
        <Formik
            //validationSchema={stepTwoValidationSchema}
            initialValues={props.data}
            onSubmit={handleSubmit}
        >
            {({ values }) => (
                <Form>
                    
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card-body" style={{ paddingLeft: "50px" }}>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <form>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Qualified Auditor to appoint: </label>
                                                            <div className="col-sm-4">
                                                                <FormikControl control='input' type="text" name='qualifiedAuditorAppoint' />
                                                            </div>
                                                            <label htmlFor="staticEmail" className="col-sm-2">Technical Expert:</label>
                                                            <div className="col-sm-4">
                                                                <FormikControl control='input' type="text" name='technicalExpert' />
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Co-auditor</label>
                                                            <div className="col-sm-4">
                                                                <FormikControl control='input' type="text" name='coAuditor' />
                                                            </div>
                                                        </div>
                                                        <br></br>
                                                        <div className="row">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Reason for the reduction/increase of M/D</label>
                                                            <div className="col-lg-9 col-lg-offset-1">
                                                                <table className="table">
                                                                    <tbody >
                                                                        <tr>
                                                                            <td>Increase:<ul><li>
                                                                                Complicated logistics
                                                                            </li>
                                                                                <li>
                                                                                    Interpreter needed
                                                                                </li>
                                                                                <li>
                                                                                    Very large site/number of employees
                                                                                </li>
                                                                                <li>High degree of regulation</li>
                                                                                <li>Highly complex processes </li>
                                                                                <li>High number of unique activities</li>
                                                                                <li>Combination of hardware, software, process, and service</li>
                                                                                <li>Require visiting temporary sites </li>
                                                                                <li>
                                                                                    High Risk Level</li>

                                                                            </ul></td>
                                                                            <td>Decrease:
                                                                                <ul>
                                                                                    <li>Design and/or other key standard elements absent </li>
                                                                                    <li>No/low risk product/processes </li>
                                                                                    <li>Prior CB knowledge of organization system </li>
                                                                                    <li>Very small site for number of employees</li>
                                                                                    <li>Client preparedness for registration</li>
                                                                                    <li>Already certified to another system</li>
                                                                                    <li>Processes involve a single general activity</li>
                                                                                    <li>Maturity of management system</li>
                                                                                    <li>High % of employees doing the same, simple tasks</li>
                                                                                    <li>Identical activities performed on all shifts </li>
                                                                                    <li>Repetitive Activities</li>
                                                                                </ul></td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-4">Application Accepted / Rejected (Reason if declined) </label>
                                                            <div className="col-sm-4">
                                                                <FormikControl control='input' type="text" name='applicationAcceptedRejected' />
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-4">Review Conducted By (Secretariat / MT)</label>
                                                            <div className="col-sm-4">
                                                                <FormikControl control='input' type="text" name='reviewConductedBy' />
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-4">External Review Conducted By</label>
                                                            <div className="col-sm-4">
                                                                <FormikControl control='input' type="text" name='externalReviewConductedBy' />
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2">Approved by (DT) </label>
                                                            <div className="col-sm-4">
                                                                <FormikControl control='input' type="text" name='approvedBy' />
                                                            </div>
                                                            <div className="col-sm-4">
                                                                <FormikControl control='date' dateFormat="dd-MM-yyyy" name='appvDate' />
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div className="card-footer">
                    <div className="row">
                        <div className="col-lg-9"></div>
                        <div className="col-lg-1" >
                            <button type="button" className="btn btn-primary" onClick={() => props.prev(values)}>
                                Back
                            </button>
                        </div>
                        <div className="col-lg-1" >
                            <button type="submit" className="btn btn-primary">Submit</button>
                        </div>
                    </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
};
